import { ListTableColumn, createListTableColumns, renderDateTime } from "sprint-common-web";

import { EditSystemButton } from "./buttons/EditSystemButton";
import { SystemItem } from "./SystemItem";

export const createSystemListingColumns = (): ListTableColumn<SystemItem>[] => {
    return createListTableColumns<SystemItem>([
        {
            type: "basic",
            key: "name",
            name: "Name",
            minWidth: 100,
            maxWidth: 150,
            isSortable: true
        },
        {
            type: "basic",
            key: "description",
            name: "Description",
            minWidth: 200,
            maxWidth: 300
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 100,
            maxWidth: 200,
            onRender: renderDateTime,
            isSortable: true
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 96,
            maxWidth: 96,
            buttons: [
                {
                    id: "edit",
                    render: EditSystemButton
                }
            ]
        }
    ]);
};
